/*********************************************************************************
 1. Dependencies
 *********************************************************************************/

import styled from 'styled-components';


/*********************************************************************************
 2. Component
 *********************************************************************************/

// Flex properties commented out until support for IE11 is dropped
export const StyledContainer = styled.div`
  // display: flex;
  // min-height: 100vh;
  // flex-direction: column;
`;



// WEBPACK FOOTER //
// ./src/components/atoms/StyledContainer/index.js